<div class="flex flex-column md:flex-row w-full gap-5 md:gap-0">
  <div class="md:col-5 lg:col-4 col-12 p-0 md:pr-3 flex flex-column gap-4">
    <div class="flex flex-column gap-2">
      <p-button (click)="getPastQuestionSubmissions()" styleClass="essay_btn"
        class="flex align-items-center cursor-pointer justify-content-between font-normal text-base text-bluegray-700 hover:text-bluegray-900 active:text-bluegray-900 border-1 border-bluegray-300 border-round-lg bg-white hover:bg-bluegray-100 active:bg-bluegray-100">
        <span>Common Essays</span>
        <i class="pi pi-angle-right"></i>
      </p-button>
      <!-- <p-button styleClass="essay_btn"
        class="flex align-items-center cursor-pointer justify-content-between font-normal text-base text-bluegray-700 hover:text-bluegray-900 active:text-bluegray-900 border-1 border-bluegray-300 border-round-lg bg-white hover:bg-bluegray-100 active:bg-bluegray-100">
        <span>Activities List</span>
        <i class="pi pi-angle-right"></i>
      </p-button>
      <p-button styleClass="essay_btn"
        class="flex align-items-center cursor-pointer justify-content-between font-normal text-base text-bluegray-700 hover:text-bluegray-900 active:text-bluegray-900 border-1 border-bluegray-300 border-round-lg bg-white hover:bg-bluegray-100 active:bg-bluegray-100">
        <span>Recommendation</span>
        <i class="pi pi-angle-right"></i>
      </p-button> -->
    </div>
    <div class="flex flex-column gap-3">
      <b class="text-xl font-bold">My Colleges</b>
      <div *ngFor="let institute of myInstitutes;" class="flex flex-column gap-2">
        <p-button styleClass="essay_btn" (click)="getPastQuestionSubmissions(institute.id)"
          class="flex align-items-center cursor-pointer justify-content-between font-normal text-base text-bluegray-700 hover:text-bluegray-900 active:text-bluegray-900 border-1 border-bluegray-300 border-round-lg bg-white hover:bg-bluegray-100 active:bg-bluegray-100">
          <span>{{institute.instituteName}}</span>
          <i class="pi pi-angle-right"></i>
        </p-button>
      </div>
      <div class="w-full mt-2">
        <div (click)="openAdditionalInfo()" class="w-full flex align-items-center justify-content-between py-2 px-3 cursor-pointer"
          style="background-color: #CDD12A; border-radius: 8px;">
          <h2 class="text-left font-medium text-lg">Task</h2>
          <a class="flex-shrink-0 py-2 p-3 bg-white border-round-2xl"><i class="pi pi-file-word"></i> Essay Pilot</a>
        </div>
      </div>
    </div>
  </div>

  <div class="md:col-7 lg:col-8 col-12 p-0 md:pl-3">
    <div *ngIf="currentSelectedTab === selectedTab.essaypilot">
      <div *ngIf="isLoading" class="flex gap-4 align-items-center justify-content-center py-5">
        <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" fill="var(--surface-ground)"
          animationDuration=".5s" />
      </div>
      <div class="flex w-full flex-column gap-3">
        <b class="block w-full text-left font-bold text-2xl" style="letter-spacing: -1px;">Recent Submissions</b>
        <div class="flex flex-column gap-4 border-1 border-round-lg p-3 border-bluegray-200 bg-white">
          <b class="font-bold text-left" style="color: #313131; font-size: 18px;">Essay pilot is here to help you
            navigate
            through the whirlwind of
            college essays.</b>

          <div class="flex flex-column gap-4" *ngIf="currentPilotType === pilotType.common && !isLoading">
            <div *ngFor="let commonQuestion of recentQuestions, let i = index" class="flex flex-column gap-3  bg-white">
              <div class="flex gap-3 ">

                <div
                  class="flex-shrink-0 w-2rem h-2rem border-circle flex align-items-center justify-content-center font-bold text-base"
                  style="background-color: #CED12A; color: #313131;">{{i+1}}</div>
                <div class="flex w-full flex-column gap-2 border-1 bg-white"
                  style="border-color: #CCD7E7; border-radius:0 8px 8px 8px;">
                  <button pButton type="button" (click)="getRecentCommonSubmissions(commonQuestion)"
                    class="p-button-text">
                    <b class="block w-full text-left font-medium text-base" style="color: #313131;">
                      {{commonQuestion.name}}
                    </b>
                    <b class="block w-full text-right font-medium text-base" style="color: #313131;">Requested Word Limit:
                      {{commonQuestion.wordlimit}}
                    </b>
                  </button>
                  <!-- <small class="block w-full text-left font-normal" style="color: #898989;">--25 Jan 2025--</small> -->
                </div>
              </div>
            </div>

          </div>
          <div *ngIf="currentPilotType === pilotType.specific && !isLoading" class="flex w-full flex-column gap-2">
            <div *ngFor="let instituteQuestion of recentQuestions, let i = index"
              class="w-full flex align-items-start gap-2">
              <div
                class="flex-shrink-0 w-2rem h-2rem border-circle flex align-items-center justify-content-center font-bold text-base"
                style="background-color: #CED12A; color: #313131;">{{i+1}}</div>
              <div class="flex w-full flex-column gap-2 border-1 bg-white"
                style="border-color: #CCD7E7; border-radius:0 8px 8px 8px;">
                <button pButton type="button" (click)="getRecentSubmissions(instituteQuestion,instituteId)"
                  class="p-button-text">
                  <b class="block w-full text-left font-medium text-base" style="color: #313131;">
                    {{ instituteQuestion.name }}
                  </b>
                  <b class="block w-full text-right font-medium text-base" style="color: #313131;">Requested Word Limit:
                    {{instituteQuestion.wordlimit}}
                  </b>
                </button>
                <!-- <small class="block w-full text-left font-normal" style="color: #898989;">--25 Jan 2025--</small> -->
              </div>
            </div>
            <!-- Static question were here -->

            <!-- Static question were here -->
          </div>
        </div>
      </div>
    </div>
    <app-additional-information-right-section *ngIf="currentSelectedTab === selectedTab.additionalInfo"
      [infoType]="infotype.EssayPilot"></app-additional-information-right-section>
  </div>
</div>

<p-dialog *ngIf="visible" header="Past Submissions" [modal]="true" [(visible)]="visible" [style]="{'width': '99%', 'min-height': '99%'}">
  <app-review-submission (closeReviewDialog)="closeDialog()" class="w-full" [currentIndex]="currentSelectedIndex" [submissions] = "pastSubmissions" ></app-review-submission>
</p-dialog>
